import ApiService from './api-service';

const OpenApiService = {
  async getApiKeys(shortCode) {
    const body = {
      query: `{
        organisation {
          apiKeys {
            key
            secret
            createdAt
          }
        }
      }`,
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    if (!data.organisation) throw new Error('Organisation does not exist');

    const mostRecentKeys =
      data.organisation.apiKeys &&
      data.organisation.apiKeys.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      })[0];

    return (
      mostRecentKeys || {
        key: undefined,
        secret: undefined,
        createdAt: undefined,
      }
    );
  },
  async recycleApiKeys(ShortCode, apiKey) {
    const body = {
      query: `mutation($apiKey: String!) {
        recycleAPIKeys(apiKey: $apiKey) {
          key
          secret
          createdAt
        }
      }`,
      variables: {
        apiKey,
      },
    };

    const data = await ApiService.orgEndpoint(ShortCode).post('/', body);
    return data.recycleAPIKeys;
  },
  async generateApiKey(ShortCode) {
    const body = {
      query: `mutation {
        generateApiKey {
          key
          secret
          createdAt
        }
      }`,
    };

    const data = await ApiService.orgEndpoint(ShortCode).post('/', body);
    return data.generateApiKey;
  },
};

export default OpenApiService;
